import { GET_CUSTOMER_PAYMENT_REQUEST,
    GET_CUSTOMER_PAYMENT_SUCCESS,
    GET_CUSTOMER_PAYMENT_ERROR, } from "../actions/types";


    
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        
           
        case GET_CUSTOMER_PAYMENT_REQUEST:
            return {
                loading: true,
            };
        case GET_CUSTOMER_PAYMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_CUSTOMER_PAYMENT_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };
        default:
            return state;
    }
}
